export const getCountryCode = (): string => 
{
    const countryCode = (document.getElementById('countryCode') as HTMLInputElement)?.value;

    return countryCode;
}